export const ethPlaces = 18;
export const ethRegex = /^\d+\.\d+$/;

export const playTokenPlaces = 6;
export const playTokenRegex = /^\d+\.\d+$/;

export const mockensPlaces = 18;
export const mockensRegex = /^\d+\.\d+$/;
